import { CheckCircle, Play, BookOpen, Lightbulb, Brain, Shield, Trophy } from 'lucide-react';

const STEP_ICONS: Record<string, React.ElementType> = {
  welcome: BookOpen, watch: Play, learn: Lightbulb, practise: Brain,
  check: Shield, readiness: CheckCircle, summary: Trophy,
};
const STEP_LABELS: Record<string, string> = {
  welcome: 'Welcome', watch: 'Watch', learn: 'Learn', practise: 'Practise',
  check: 'Check', readiness: 'Ready', summary: 'Done',
};

export default function StepIndicator({ steps, current, completedSteps, onStepClick }: {
  steps: string[];
  current: number;
  completedSteps: Set<string>;
  onStepClick: (i: number) => void;
}) {
  return (
    <div className="flex gap-1 items-center px-1">
      {steps.map((step, i) => {
        const Icon = STEP_ICONS[step] || BookOpen;
        const done = completedSteps.has(step);
        const active = i === current;
        const canClick = done || i <= current;
        return (
          <button key={step} onClick={() => canClick && onStepClick(i)}
            className={`flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-lg transition-all text-[10px] leading-tight ${
              active ? 'bg-primary/10 text-primary font-bold' :
              done ? 'text-primary/70' : 'text-muted-foreground'
            } ${canClick ? 'cursor-pointer' : 'cursor-default opacity-50'}`}>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
              done ? 'bg-primary text-primary-foreground' :
              active ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'
            }`}>
              {done ? <CheckCircle className="w-3.5 h-3.5" /> : <Icon className="w-3.5 h-3.5" />}
            </div>
            <span className="truncate w-full text-center">{STEP_LABELS[step] || step}</span>
          </button>
        );
      })}
    </div>
  );
}
